import { buildPrompt } from "./buildPrompt";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // adjust path as needed
import { parseMaterialFromText } from "./parseMaterialFromText";
import { rollMaterialStats } from "./rollMaterialStats"; // <<=== NEW!

const YOUR_OLLAMA_URL = "https://ai.echoesofthewild.app";

export const saveMaterialToFirestore = async (material) => {
  try {
    await addDoc(collection(db, "discoveredMaterials"), {
      ...material,
      createdAt: serverTimestamp(),
    });
    console.log("📁 Saved material to Firestore:", material);
  } catch (error) {
    console.error("❌ Failed to save material:", error);
  }
};

export const generateMaterial = async (
  currentLocation,
  currentEvent,
  adventureLogs
) => {
  const { rarityRoll, rarity, qualityRoll, quality } = rollMaterialStats();
  console.log(`🎲 Rarity Roll: ${rarityRoll} → ${rarity}`);
  console.log(`🎲 Quality Roll: ${qualityRoll} → ${quality}`);

  const prompt = buildPrompt(
    currentLocation,
    currentEvent,
    adventureLogs,
    rarity,
    quality
  );

  try {
    console.log("🧠 Sending prompt to AI:", prompt);

    const response = await fetch(`${YOUR_OLLAMA_URL}/api/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "mistral",
        prompt,
      }),
    });

    console.log("📦 Raw response:", response);

    const rawText = await response.text();
    console.log("📜 Raw streamed text:", rawText);

    const lines = rawText.split("\n").map((line) => {
      try {
        return JSON.parse(line).response || "";
      } catch (e) {
        return "";
      }
    });

    const combinedText = lines.join("").trim();

    console.log("📜 Full combined AI output:", combinedText);

    const material = parseMaterialFromText(combinedText);
    console.log("🧪 Parsed material:", material);

    await saveMaterialToFirestore(material);
    return material;
  } catch (error) {
    console.error("❌ Failed to generate material:", error);
    return null;
  }
};
